import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  HiOutlineArrowsExpand,
  HiOutlineHome,
  HiCog,
  HiMenuAlt1,
  HiOutlineCog,
  HiOutlineUserGroup,
  HiCurrencyDollar,
  HiOutlineIdentification,
  HiCalendar,
  HiOutlineLibrary,
  HiOutlineDocumentText,
  HiOutlinePhotograph,
  HiOutlineChevronDown,
  HiOutlineChevronRight,
  HiOutlineUsers,
  HiOutlineViewGridAdd,
  HiOfficeBuilding,
  HiCreditCard,
  HiOutlineMenu, // Hamburger Menu icon
} from "react-icons/hi"; // Sidebar icons
import official_logo from '../assets/logo/white.png';

const Sidebar = ({propertyID,setMiniSidebar,isMiniSidebar}) => {
  const [isSidebarOpen, setSidebarOpen] = useState(true); // Full Sidebar for Desktop
  const [openMenu, setOpenMenu] = useState(null); // Track which menu is open

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };
  
  return (
    <>
      {/* Sidebar only renders when isSidebarOpen is true */}
        <aside
          className={`fixed md:static transition-all duration-300 h-full z-50 ${
            isSidebarOpen ? "w-56" : "w-16"  // Full width for desktop or mini width for mobile
          } bg-[#070f23] text-slate-400 flex flex-col ${
            isMiniSidebar ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0`}
        >
          {/* Mobile Hamburger Button */}
          <div className="p-4 md:hidden">
            <button onClick={()=>setMiniSidebar(!isMiniSidebar)} className="text-white focus:outline-none">
              <HiOutlineMenu size={24} />
            </button>
          </div>

          {/* Logo Section */}
          <div className="p-4 py-5 flex items-center justify-center shadow-sm h-16">
            {/* Full Logo for Expanded Sidebar or in Mobile Sidebar */}
            <span className={`transition-all duration-300 ${!isSidebarOpen && "hidden"}`}>
              <img src={official_logo} alt="ahg_logo" className="w-24 h-16" />
            </span>
            {/* Mini Icon + Text for Collapsed Sidebar */}
            <span className={`text-base font-bold transition-all duration-300 ${isSidebarOpen && "hidden"}`}>
              A.H.G
            </span>
          </div>

          {/* Navigation */}
          <nav className="pt-4 flex-1 bg-[#101827] text-[#F4DDBE] text-xs h-full">
            <ul className="space-y-2">
              {/* Dashboard */}
              <li>
                <Link to={`/dashboard`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <HiOutlineHome size={20} className="mr-3" />
                  {isSidebarOpen && "Dashboard"}
                </Link>
              </li>

              {/* Setting */}
          
              {/* Site setting with Submenu */}
              <li>
                <button onClick={() => toggleMenu("site")} className="flex items-center justify-between w-full px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <div className="flex items-center">
                    <HiOfficeBuilding size={20} className="mr-3" />
                    {isSidebarOpen && "Site & Property"}
                  </div>
                  {isSidebarOpen &&
                    (openMenu === "site" ? (
                      <HiOutlineChevronDown size={20} />
                    ) : (
                      <HiOutlineChevronRight size={20} />
                    ))}
                </button>
                {isSidebarOpen && openMenu === "site" && (
                  <ul className="pl-4 mt-2 space-y-2">
                    <li>
                      <Link
                        to={`/configuration/${propertyID}`}
                        className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600"
                      >
                        <HiCog size={20} className="mr-3" />
                        {isSidebarOpen && "Profile"}
                      </Link>
                    </li>

                    <li>
                      <Link
                        to={`/integration/${propertyID}`}
                        className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600"
                      >
                        <HiCog size={20} className="mr-3" />
                        {isSidebarOpen && "API - Integration"}
                      </Link>
                    </li>

                    {/* <li>
                      <Link
                        to={`/rooms/image/${propertyID}`}
                        className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600"
                      >
                        <HiCog size={20} className="mr-3" />
                        {isSidebarOpen && "Gallery"}
                      </Link>
                    </li> */}
                  </ul>
                )}
              </li>

              {/* Rooms with Submenu */}
              <li>
                <button onClick={() => toggleMenu("rooms")} className="flex items-center justify-between w-full px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <div className="flex items-center">
                    <HiOutlineLibrary size={20} className="mr-3" />
                    {isSidebarOpen && "Rooms"}
                  </div>
                  {isSidebarOpen &&
                    (openMenu === "rooms" ? (
                      <HiOutlineChevronDown size={20} />
                    ) : (
                      <HiOutlineChevronRight size={20} />
                    ))}
                </button>
                {isSidebarOpen && openMenu === "rooms" && (
                  <ul className="pl-4 mt-2 space-y-2">
                    <li>
                      <Link to={`/rooms/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineCog size={20} className="mr-3" />
                        {isSidebarOpen && "Configuration"}
                      </Link>
                    </li>
                    <li>
                      <Link to={`/rooms/rate/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineDocumentText size={20} className="mr-3" />
                        {isSidebarOpen && "Rate"}
                      </Link>
                    </li>
                    <li>
                      <Link to={`/rooms/image/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlinePhotograph size={20} className="mr-3" />
                        {isSidebarOpen && "Image / Media "}
                      </Link>
                    </li>
                    <li>
                      <Link to={`/rooms/facilities/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineViewGridAdd size={20} className="mr-3" />
                        {isSidebarOpen && "Facilities "}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Room Rate */}
              <li>
                <button onClick={() => toggleMenu("rate")} className="flex items-center justify-between w-full px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <div className="flex items-center">
                    <HiCurrencyDollar size={20} className="mr-3" />
                    {isSidebarOpen && "Rate Plan"}
                  </div>
                  {isSidebarOpen &&
                    (openMenu === "rate" ? (
                      <HiOutlineChevronDown size={20} />
                    ) : (
                      <HiOutlineChevronRight size={20} />
                    ))}
                </button>
                {isSidebarOpen && openMenu === "rate" && (
                  <ul className="pl-4 mt-2 space-y-2">
                    <li>
                      <Link to={`/room-rate/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineCog size={20} className="mr-3" />
                        {isSidebarOpen && "Configuration"}
                      </Link>
                    </li>
                    <li>
                      <Link to={`/rate-setting/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiCalendar size={20} className="mr-3" />
                        {isSidebarOpen && "Rate Setting"}
                      </Link>
                    </li>

                    <li>
                      <Link to={`/rate-image/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiCreditCard size={20} className="mr-3" />
                        {isSidebarOpen && "Rate Image"}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Transaction Setting */}
              <li>
                <button onClick={() => toggleMenu("transaction")} className="flex items-center justify-between w-full px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <div className="flex items-center">
                    <HiOutlineIdentification size={20} className="mr-3" />
                    {isSidebarOpen && "Transaction "}
                  </div>
                  {isSidebarOpen &&
                    (openMenu === "transaction" ? (
                      <HiOutlineChevronDown size={20} />
                    ) : (
                      <HiOutlineChevronRight size={20} />
                    ))}
                </button>
                {isSidebarOpen && openMenu === "transaction" && (
                  <ul className="pl-4 mt-2 space-y-2">
                    <li>
                      <Link to={`/transaction/${propertyID}`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineUserGroup size={20} className="mr-3" />
                        {isSidebarOpen && "Guest List"}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Account Setting */}
              <li>
                <button onClick={() => toggleMenu("account")} className="flex items-center justify-between w-full px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                  <div className="flex items-center">
                    <HiOutlineUsers size={20} className="mr-3" />
                    {isSidebarOpen && "Account"}
                  </div>
                  {isSidebarOpen &&
                    (openMenu === "account" ? (
                      <HiOutlineChevronDown size={20} />
                    ) : (
                      <HiOutlineChevronRight size={20} />
                    ))}
                </button>
                {isSidebarOpen && openMenu === "account" && (
                  <ul className="pl-4 mt-2 space-y-2">
                    <li>
                      <Link to={`/account-setting/`} className="flex items-center px-4 py-2 hover:mx-1 hover:bg-gray-700 hover:shadow rounded-lg transition duration-600">
                        <HiOutlineCog size={20} className="mr-3" />
                        {isSidebarOpen && "Setting"}
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Additional Links */}
            </ul>
          </nav>

          {/* Footer */}
          <div className="p-4 bg-[#101827]">
          <div className="flex justify-center items-center space-x-4 gap-1 my-5">
            <div className="flex text-xs justify-center items-center">
              <HiOutlineArrowsExpand size={20} className="mr-2" onClick={()=>setSidebarOpen(!isSidebarOpen)}/>
            </div>

            {/* Show Mini sidebar */}
            <div className="flex text-xs justify-center items-center">
              <HiMenuAlt1 size={20} className="mr-2" onClick={()=>setMiniSidebar(!isMiniSidebar)}/>
            </div>
            
            </div>

            <p className="text-xs text-center text-gray-500">
              {isSidebarOpen && "2025 © Ashley Hotel Group"}
            </p>
          </div>
        </aside>
      
    </>
  );
};

export default Sidebar;
